import {
  LucideBanana,
  LucideCigarette,
  LucideCookingPot,
  LucideDrumstick,
  LucideGlassWater,
  LucideHandPlatter,
  LucideMartini,
  LucideMilk,
  LucideSalad,
  LucideStore,
  LucideWine
} from 'lucide-react';
import type { SearchCategory, SelectableItem } from '~/features/catalog/components/navigation/CategoryNavigation';
import { memo } from 'react';

export interface CatalogNavigationIconProps {
  category: SelectableItem<SearchCategory>;
}

export const HwgIcon = memo(({ category }: Readonly<CatalogNavigationIconProps>) => {
  if (category.item.type === null) {
    return <LucideStore />;
  }

  if (category.item.type === 'hwg') {
    switch (category.item.path.hwgId) {
      case 1:
        return <LucideSalad />;
      case 2:
        return <LucideCigarette />;
      case 3:
        return <LucideWine />;
      case 4:
        return <LucideMartini />;
      case 5:
        return <LucideGlassWater />;
      case 6:
        return <LucideMilk />;
      case 7:
        return <LucideBanana />;
      case 8:
        return <LucideDrumstick />;
      case 9:
        return <LucideCookingPot />;
      case 10:
        return <LucideHandPlatter />;
      default:
        return null;
    }
  }
  return null;
});

HwgIcon.displayName = 'HwgIcon';
